module.exports = __webpack_public_path__ + "static/thpglogo-grayscaled-437b4bea4860ee1c27a3d3283545848f.png";